module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "llr-page"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "llr-toolbar"
  }, [_c('div', {
    staticClass: "llr-filter"
  }, [_c('span', {
    staticClass: "llr-filter-icon"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('rect', {
    attrs: {
      "x": "3",
      "y": "4",
      "width": "18",
      "height": "18",
      "rx": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16 2v4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8 2v4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3 10h18"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "llr-month-picker"
  }, [_c('vue-monthly-picker', {
    attrs: {
      "selectedBackgroundColor": _vm.selectedBackgroundColor,
      "monthLabels": _vm.locale,
      "dateFormat": _vm.dateFormat,
      "placeHolder": "All Time"
    },
    on: {
      "selected": _vm.handleSelect
    },
    model: {
      value: (_vm.selectedMonth),
      callback: function($$v) {
        _vm.selectedMonth = $$v
      },
      expression: "selectedMonth"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "llr-toolbar-actions"
  }, [_c('button', {
    staticClass: "llr-add-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showAddLuckyModal
    }
  }, [_c('svg', {
    staticClass: "llr-btn-icon",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 5v14"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5 12h14"
    }
  })]), _vm._v("\n        Add Manually\n      ")]), _vm._v(" "), _c('runner-field-visibility-control', {
    attrs: {
      "modal-name": "luckyLiveRunnerFieldVisibility",
      "title": "Lucky LiveRunner Fields",
      "subtitle": "Choose the columns shown on this page",
      "field-options": _vm.fieldOptions,
      "selected-fields": _vm.selectedFieldIds
    },
    on: {
      "apply": _vm.applyFieldSelection,
      "reset": _vm.resetFieldSelection
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "lucky-liverunner llr-card"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "llr-skeleton-table"
  }, _vm._l((4), function(row) {
    return _c('div', {
      key: 'llr-skeleton-' + row,
      staticClass: "llr-skeleton-row"
    }, _vm._l((_vm.visibleLuckyColumns.length), function(cell) {
      return _c('div', {
        key: 'llr-skeleton-' + row + '-' + cell,
        staticClass: "llr-skeleton-cell sk-shimmer"
      })
    }), 0)
  }), 0) : (_vm.tableData.length === 0) ? _c('div', {
    staticClass: "llr-empty"
  }, [_c('span', {
    staticClass: "llr-empty-icon"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M20 12v7a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-7"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2 7h20v5H2z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12 22V7"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12 7H7.5a2.5 2.5 0 1 1 0-5C11 2 12 7 12 7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12 7h4.5a2.5 2.5 0 1 0 0-5C13 2 12 7 12 7z"
    }
  })])]), _vm._v(" "), _c('h2', {
    staticClass: "llr-empty-title"
  }, [_vm._v("No lucky runners found")]), _vm._v(" "), _c('p', {
    staticClass: "llr-empty-text"
  }, [_vm._v("Choose another month or add a lucky runner manually.")])]) : _c('div', {
    staticClass: "llr-table-wrap"
  }, [_c('table', {
    staticClass: "llr-table"
  }, [_c('thead', [_c('tr', _vm._l((_vm.visibleLuckyColumns), function(column) {
    return _c('th', {
      key: column.id,
      class: _vm.luckyColumnClass(column.id)
    }, [_vm._v(_vm._s(column.label))])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.tableData), function(runner, index) {
    return _c('tr', {
      key: runner.id || index
    }, _vm._l((_vm.visibleLuckyColumns), function(column) {
      return _c('td', {
        key: column.id,
        class: _vm.luckyColumnClass(column.id)
      }, [(column.id === 'race-date') ? _c('span', [_vm._v(_vm._s(_vm.raceDate(runner)))]) : (column.id === 'run-start') ? _c('span', [_vm._v(_vm._s(_vm.raceTime(runner)))]) : (column.id === 'run-name') ? _c('a', {
        staticClass: "llr-run-link",
        attrs: {
          "href": _vm.pastRunHref(runner),
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(_vm.displayValue(runner.runName)))]) : (column.id === 'trainer') ? _c('span', [_vm._v(_vm._s(_vm.displayValue(runner.trainerName)))]) : (column.id === 'runner-id') ? _c('button', {
        staticClass: "llr-id-link",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            return _vm.openRunnerData(runner.runnerId)
          }
        }
      }, [_vm._v(_vm._s(_vm.displayValue(runner.runnerId)))]) : (column.id === 'runner-name') ? _c('span', [_vm._v(_vm._s(_vm.displayValue(runner.runnerName)))]) : (column.id === 'sent-date') ? _c('span', [_vm._v(_vm._s(_vm.displayValue(runner.presentSentDate)))]) : (column.id === 'present-content') ? _c('span', [_vm._v(_vm._s(_vm.displayValue(runner.presentContent)))]) : (column.id === 'note') ? _c('span', [_vm._v(_vm._s(_vm.displayValue(runner.note)))]) : (column.id === 'actions') ? _c('div', {
        staticClass: "llr-row-actions"
      }, [_c('button', {
        staticClass: "llr-icon-btn",
        attrs: {
          "type": "button",
          "title": "Edit lucky runner"
        },
        on: {
          "click": function($event) {
            return _vm.editLuckyRunner(runner, index)
          }
        }
      }, [_c('svg', {
        attrs: {
          "viewBox": "0 0 24 24",
          "fill": "none",
          "stroke": "currentColor",
          "stroke-width": "1.8",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      }, [_c('path', {
        attrs: {
          "d": "M12 20h9"
        }
      }), _vm._v(" "), _c('path', {
        attrs: {
          "d": "M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z"
        }
      })])]), _vm._v(" "), _c('button', {
        staticClass: "llr-icon-btn llr-icon-btn--danger",
        attrs: {
          "type": "button",
          "title": "Delete lucky runner"
        },
        on: {
          "click": function($event) {
            return _vm.deleteLuckyRunner(runner, index)
          }
        }
      }, [_c('svg', {
        attrs: {
          "viewBox": "0 0 24 24",
          "fill": "none",
          "stroke": "currentColor",
          "stroke-width": "1.8",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      }, [_c('path', {
        attrs: {
          "d": "M3 6h18"
        }
      }), _vm._v(" "), _c('path', {
        attrs: {
          "d": "M8 6V4h8v2"
        }
      }), _vm._v(" "), _c('path', {
        attrs: {
          "d": "M19 6l-1 14H6L5 6"
        }
      }), _vm._v(" "), _c('path', {
        attrs: {
          "d": "M10 11v5"
        }
      }), _vm._v(" "), _c('path', {
        attrs: {
          "d": "M14 11v5"
        }
      })])])]) : _vm._e()])
    }), 0)
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "llr-pagination-wrap"
  }, [_c('v-pagination', {
    attrs: {
      "pageIndex": _vm.pageIndex + 1,
      "total": _vm.pageTotal,
      "page-size": _vm.pageSize,
      "layout": ['total', 'prev', 'pager', 'next', 'sizer', 'jumper']
    },
    on: {
      "page-change": _vm.pageChange,
      "page-size-change": _vm.pageSizeChange
    }
  })], 1), _vm._v(" "), _c('edit-lucky-live-runner', {
    attrs: {
      "runnerData": _vm.runnerData,
      "show": _vm.showEditModal
    },
    on: {
      "saved": _vm.onSaved,
      "closed": _vm.onClosed
    }
  }), _vm._v(" "), _c('add-lucky-live-runner', {
    attrs: {
      "show": _vm.showAddModal
    },
    on: {
      "saved": _vm.onSaved,
      "closed": _vm.onClosed
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pg-title-row"
  }, [_c('div', [_c('h1', {
    staticClass: "pg-title"
  }, [_vm._v("Lucky LiveRunner")]), _vm._v(" "), _c('p', {
    staticClass: "pg-title-sub"
  }, [_vm._v("Manage monthly lucky runner gift records and sent status")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58592e77"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/AllLuckyLiveRunners.vue
// module id = 1711
// module chunks = 2